import React from 'react';
import { Grid, TextField, Chip, Box, Typography } from '@mui/material';

const VistaAsignacion = ({ data }) => {
    // Función para formatear fechas
    const formatearFecha = (fechaStr) => {
        if (!fechaStr) return 'No disponible';

        const partes = fechaStr.split(/[- :]/);
        const fecha = new Date(partes[0], partes[1] - 1, partes[2], partes[3] || 0, partes[4] || 0, partes[5] || 0);

        const dia = fecha.getDate();
        const mes = fecha.getMonth() + 1;
        const año = fecha.getFullYear();
        let horas = fecha.getHours();
        const minutos = String(fecha.getMinutes()).padStart(2, '0');
        const ampm = horas >= 12 ? 'PM' : 'AM';

        horas = horas % 12;
        horas = horas ? horas : 12;

        return `${dia}-${mes}-${año} ${String(horas).padStart(2, '0')}:${minutos} ${ampm}`;
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <TextField fullWidth label="Curso" value={data?.nombreCurso || ''} InputProps={{ readOnly: true }} variant="filled" />
            </Grid>

            <Grid item xs={12}>
                <TextField fullWidth label="Grupo" value={data?.nombreGrupo || ''} InputProps={{ readOnly: true }} variant="filled" />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    label="Fecha Inicio del Curso"
                    value={formatearFecha(data?.fechaInicioCurso)}
                    InputProps={{ readOnly: true }}
                    variant="filled"
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    label="Fecha Fin del Curso"
                    value={formatearFecha(data?.fechaFinCurso)}
                    InputProps={{ readOnly: true }}
                    variant="filled"
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    label="Fecha de Creación"
                    value={formatearFecha(data?.fechaCreacion)}
                    InputProps={{ readOnly: true }}
                    variant="filled"
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    label="Fecha de Modificación"
                    value={formatearFecha(data?.fechaModificacion)}
                    InputProps={{ readOnly: true }}
                    variant="filled"
                />
            </Grid>

            <Grid item xs={12}>
                <Box>
                    <Typography variant="body2" color="textSecondary" gutterBottom>
                        Estatus
                    </Typography>
                    <Chip
                        label={data?.estatus === '1' || data?.estatus === 1 ? 'Activo' : 'Inactivo'}
                        color={data?.estatus === '1' || data?.estatus === 1 ? 'success' : 'default'}
                        sx={{ mt: 1 }}
                    />
                </Box>
            </Grid>

            <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="Observaciones"
                    value={data?.observaciones || 'Sin observaciones'}
                    InputProps={{ readOnly: true }}
                    variant="filled"
                    multiline
                    rows={4}
                />
            </Grid>
        </Grid>
    );
};

export default VistaAsignacion;
